import React from 'react'
import CacheLayout from './CacheLayout'

const Cache = () => {
  return <CacheLayout />
}

export default Cache
